import { useLocation, useNavigate } from "react-router-dom";
import axiosInstance from "../../api/axiosInstance.js";
import { useEffect, useRef, useState } from "react";
import { MdDeleteForever } from "react-icons/md";
import { BiSolidEditAlt } from "react-icons/bi";
import Loader from "../../common/Loader/index.js";
import { saveAs } from "file-saver";
import { RiFilter2Fill } from "react-icons/ri";
import { KanbanBoard } from "../../common/KanbanBoard/index.jsx";
import CloseLostModal from "./CloseLostModel.js";
import { HiOutlineDotsVertical } from "react-icons/hi";
import { notify, Toast } from "../../common/Toast/index.js";
import Model from "../../common/Model/index.js";
import formatDateIndian from "../../common/formatDateIndian.js";
import { IoPrintSharp, IoCalendarClearOutline } from "react-icons/io5";
import { getUserMenuPermission } from "../../common/Helper/index.js";
import Filter from "../../common/Filter/index.js";
import { BsFileEarmarkPdfFill } from "react-icons/bs";

const stageMapping = {
  1: "Active",
  2: "Close Won",
  3: "Close Lost",
  6: "In-Production",
  7: "Delivery Complete",
  8: "In-Coating",
  9: "Prod-Complete",
  10: "Coating Complete",
};

const stageID = {
  Active: 1,
  "Close Won": 2,
  "Close Lost": 3,
  "In-Production": 6,
  "Delivery Complete": 7,
  "In-Coating": 8,
  "Prod-Complete": 9,
  "Coating Complete": 10,
};

const FinsMaterialQuotation = () => {
  const permission = getUserMenuPermission(18);
  const navigate = useNavigate();
  const [isMaterialQuotationData, setIsMaterialQuotationData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const filterBtnRef = useRef(null);
  const [selectedCard, setSelectedCard] = useState();
  const [isCustomer, setIsCustomer] = useState({});
  const [coatingParties, setCoatingParties] = useState([]);
  const [coatingType, setCoatingType] = useState([]);
  const [openMenuCard, setOpenMenuCard] = useState(null);
  const [isCloseLostModalOpen, setIsCloseLostModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [salePersons, setSalePersons] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const [filters, setFilters] = useState({
    proforma_No: "",
    customer_Id: "",
    sale_Person_Id: "",
    invoice_Creation: null,
    coating_Party_Id: "",
    coating_Type_Id: "",
    is_Urgent: false,
  });

  const [appliedFilters, setAppliedFilters] = useState({
    proforma_No: "",
    customer_Id: "",
    sale_Person_Id: "",
    invoice_Creation: null,
    coating_Party_Id: "",
    coating_Type_Id: "",
    is_Urgent: false,
  });

  const [isInvoiceModalOpen, setIsInvoiceModalOpen] = useState(false);
  const [selectedProformaForInvoice, setSelectedProformaForInvoice] =
    useState(null);
  const [invoiceFile, setInvoiceFile] = useState(null);
  const [pdfModalUrl, setPdfModalUrl] = useState(null);
  const [isPdfModalOpen, setIsPdfModalOpen] = useState(false);
  const location = useLocation();
  const filteredData = location?.state?.filteredData || [];
  const isFilteredFromDashboard =
    location.state?.isFilteredFromDashboard || false;
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    const fetchCoatingMasters = async () => {
      try {
        const [partyRes, typeRes] = await Promise.all([
          axiosInstance.get("MaterialQuotation/GetAllCoatingParties"),
          axiosInstance.get("CoatingType/GetAll"),
        ]);

        setCoatingParties(partyRes.data || []);
        setCoatingType(typeRes.data || []);
      } catch (err) {
        console.error("Error loading coating masters", err);
      }
    };

    fetchCoatingMasters();
  }, []);

  useEffect(() => {
    if (!initialized) {
      if (
        location.state?.isFilteredFromDashboard &&
        Array.isArray(location.state?.filteredData)
      ) {
        const transformed = filteredData?.map((item) => ({
          ...item,
          column: stageMapping[item.stage_Id] || "Unknown",
          type: "material-quotation",
        }));
        setIsMaterialQuotationData(transformed);
        setLoading(false);
      } else {
        fetchData();
      }
      setInitialized(true);
    }
  }, [initialized, location.state]);

  const columns = [
    "Active",
    "Close Won",
    "In-Production",
    "Prod-Complete",
    "In-Coating",
    "Coating Complete",
    "Delivery Complete",
    "Close Lost",
  ];

  const toggleMenu = (quotationNo) => {
    setOpenMenuCard((prev) => (prev === quotationNo ? null : quotationNo));
  };

  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        const res = await axiosInstance.get("Customer/GetAll");
        const customerMap = (res.data || []).reduce((acc, c) => {
          acc[c.customer_Id] = c.customer_Name;
          return acc;
        }, {});
        setIsCustomer(customerMap);
      } catch (err) {
        console.error("Error fetching customers:", err);
      }
    };
    fetchCustomers();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".menu-container")) {
        setOpenMenuCard(null);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  useEffect(() => {
    if (!isFilteredFromDashboard) {
      fetchData();
    }
  }, [appliedFilters]);

  useEffect(() => {
    const fetchSalePersons = async () => {
      try {
        const res = await axiosInstance.get("User/GetAllUser");
        const salesData = res.data.map((person) => ({
          sale_Person_Id: Number(person.sale_Person_Id),
          Sale_Person_Name: person.Sale_Person_Name,
        }));

        setSalePersons(salesData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchSalePersons();
  }, []);

  const handleCardMove = (card, newStage, oldStageId) => {
    const currentStageID = Number(oldStageId);
    const newStageID = stageID[newStage];

    if (currentStageID === 1 && (newStageID === 2 || newStageID === 3)) {
      setSelectedCard(card);
      newStageID === 2
        ? handleUpdateStage(card, newStage)
        : setIsCloseLostModalOpen(true);
    } else if (currentStageID === 2) {
      setSelectedCard(card);
      if (newStageID === 6) {
        handleUpdateStage(card, newStage);
      } else if (newStageID === 3) {
        setIsCloseLostModalOpen(true);
      }
    } else if (currentStageID === 6 && newStageID === 9) {
      handleUpdateStage(card, newStage);
    } else if (currentStageID === 9 && newStageID === 8) {
      handleUpdateStage(card, newStage);
    } else if (currentStageID === 8 && newStageID === 10) {
      handleUpdateStage(card, newStage);
    } else if (currentStageID === 10 && newStageID === 7) {
      handleUpdateStage(card, newStage);
    } else if (currentStageID === 7) {
      notify("Cannot move cards from Delivery Complete stage.");
    } else if (currentStageID === 3 && newStageID === 1) {
      handleUpdateStage(card, newStage);
    } else {
      notify(
        `Invalid move from ${stageMapping[currentStageID]} to ${stageMapping[newStageID]}`
      );
    }
  };

  const handleUpdateStage = async (card, newStage) => {
    try {
      setLoading(true);
      await axiosInstance.post("FinsMaterialQuotations/UpdateProformaStage", {
        proforma_No: card,
        stage_Id: stageID[newStage],
      });
      fetchData();
    } catch (error) {
      notify("Error updating stage:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleCloseLostSave = async (reason) => {
    try {
      setLoading(true);
      await axiosInstance.post("FinsMaterialQuotations/SaveCloseLostProforma", {
        proforma_No: selectedCard,
        Reason: reason,
      });
      fetchData();
    } catch (error) {
      notify("Error saving Close Lost:", error);
    } finally {
      setLoading(false);
    }
  };

  const applyFilters = () => {
    setAppliedFilters({
      ...filters,
      proforma_No: Number(filters.proforma_No) || 0,
      sale_Person_Id: Number(filters.sale_Person_Id) || 0,
      customer_Id: Number(filters.customer_Id) || 0,
      coating_Party_Id: Number(filters.coating_Party_Id) || 0,
      coating_Type_Id: Number(filters.coating_Type_Id) || 0,
      invoice_Creation: filters.invoice_Creation === "" ? null : filters.invoice_Creation === "true",
      is_Urgent: filters.is_Urgent === true ? true : false,
    });

    setIsFilterOpen(false);
  };

  const clearFilters = () => {
    const reset = {
      proforma_No: "",
      customer_Id: "",
      sale_Person_Id: "",
      invoice_Creation: "",
      coating_Party_Id: "",
      coating_Type_Id: "",
      is_Urgent: false,
    };
    setFilters(reset);
    setAppliedFilters({ ...reset, invoice_Creation: null, is_Urgent: null });
  };

  const fetchData = async () => {
    try {
      setLoading(true);

      const payload = {
        pageNumber: 1,
        pageSize: 10,
        proforma_No: appliedFilters.proforma_No || 0,
        sale_Person_Id: appliedFilters.sale_Person_Id || 0,
        customer_Id: appliedFilters.customer_Id || 0,
        invoice_Creation: appliedFilters.invoice_Creation !== null ? appliedFilters.invoice_Creation : null,
        coating_Party_Id: appliedFilters.coating_Party_Id || 0,
        coating_Type_Id: appliedFilters.coating_Type_Id || 0,
        is_Urgent: appliedFilters.is_Urgent || false,
      };

      const [materialRes] = await Promise.all([
        axiosInstance.post("FinsMaterialQuotations/GetAllPagination", payload),
      ]);

      const transformedData = (materialRes.data.quotations || []).map(
        (item) => ({
          ...item,
          column: stageMapping[item.stage_Id] || "Unknown",
          type: "material-quotation",
          invoice_Creation: Boolean(item.invoice_Creation),
        })
      );

      setIsMaterialQuotationData(transformedData);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = async (proforma_No) => {
    try {
      setLoading(true);
      const { data } = await axiosInstance.get(
        `FinsMaterialQuotations/GetByProformaNo/${proforma_No}`
      );
      navigate("/quotes/fins-quotation/fins-Details", {
        state: { materialQuotationData: data },
      });
      fetchData();
    } catch (error) {
      console.error("Error fetching site details:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = (id) => {
    setSelectedId(id);
    setIsDeleteModalOpen(true);
  };

  const handleConfirmDelete = async () => {
    try {
      await axiosInstance.delete(
        `FinsMaterialQuotations/DeleteMaterialQuotation/${selectedId}`
      );
      setAppliedFilters({ ...appliedFilters });
      notify("MaterialQuotation deleted successfully!", "error");
    } catch (err) {
      notify("Error deleting error:", err);
    } finally {
      setIsDeleteModalOpen(false);
      setSelectedId(null);
    }
  };

  const handlePrint = async (proforma_No) => {
    try {
      setLoading(true);

      const quotation = isMaterialQuotationData.find(
        (item) => item.proforma_No === proforma_No
      );

      const customerName = isCustomer?.[quotation?.customer_Id] || "Customer";

      const safeCustomerName = customerName.replace(/\s+/g, "_");

      const response = await axiosInstance.get(
        `FinsMaterialQuotations/FinsQuotePrint/${proforma_No}`,
        { responseType: "blob" }
      );

      if (response.status === 200) {
        const blob = new Blob([response.data], { type: "application/pdf" });
        saveAs(blob, `PI_${proforma_No}_${safeCustomerName}.pdf`);
        const url = window.URL.createObjectURL(blob);
        window.open(url, "_blank");
      } else {
        alert("Failed to generate PDF. Please try again later.");
      }
    } catch (error) {
      console.error("Error printing Fins Quotation:", error);
      const errorMessage =
        error.response?.data?.message || "Unknown error occurred.";

      if (errorMessage.includes("Select.HtmlToPdf")) {
        alert(
          "PDF generation is currently unavailable. Please contact support."
        );
      } else {
        alert(`An error occurred while printing: ${errorMessage}`);
      }
    } finally {
      setLoading(false);
    }
  };

  const salePersonOptions = [
    ...salePersons.map((sp) => ({
      value: sp.sale_Person_Id.toString(),
      label: sp.Sale_Person_Name,
    })),
  ];

  const customerOptions = Object.entries(isCustomer).map(([id, name]) => ({
    value: id,
    label: name,
  }));

  const coatingPartyOptions = coatingParties.map((c) => ({
    value: c.coating_Party_Id,
    label: c.party_Name,
  }));

  const coatingTypeOptions = coatingType.map((c) => ({
    value: c.coatingTypeId,
    label: c.coatingType,
  }));

  const filterFields = [
    {
      label: "Proforma No",
      name: "proforma_No",
      type: "text",
    },
    {
      label: "Sales Person",
      name: "sale_Person_Id",
      type: "select",
      options: salePersonOptions,
    },
    {
      label: "Customer",
      name: "customer_Id",
      type: "select",
      options: customerOptions,
    },
    {
      label: "Coating Party",
      name: "coating_Party_Id",
      type: "select",
      options: coatingPartyOptions,
    },
    {
      label: "Coating Type",
      name: "coating_Type_Id",
      type: "select",
      options: coatingTypeOptions,
    },
    {
      label: "Invoice Done",
      name: "invoice_Creation",
      type: "select",
      options: [
        { label: "All", value: "" },
        { label: "Yes", value: "true" },
        { label: "No", value: "false" },
      ],
    },
    {
      label: "Urgent",
      name: "is_Urgent",
      type: "toggle",
    },
  ];

  const renderCard = (card) => {
    const stageOptions = {
      1: ["Close Won", "Close Lost"],
      2: ["In-Production", "Close Lost"],
      6: ["Prod-Complete"],
      9: ["In-Coating"],
      8: ["Coating Complete"],
      10: ["Delivery Complete"],
      7: [],
      3: ["Active"],
    };
    const salePersonName =
      salePersons.find(
        (sp) => Number(sp.sale_Person_Id) === Number(card.sale_Person_Id)
      )?.Sale_Person_Name || "-";

    const getInitials = (name) => {
      if (!name) return "";
      const words = name.trim().split(" ");
      return words
        .slice(0, 2)
        .map((w) => w.charAt(0).toUpperCase())
        .join("");
    };

    const initials = getInitials(salePersonName);
    return (
      <div
        key={card.proforma_No}
        draggable
        onDragStart={(e) => {
          e.dataTransfer.setData("cardId", card.proforma_No?.toString());
          e.dataTransfer.setData("stageId", card.stage_Id.toString());
        }}
        className="group relative rounded-xl bg-white p-4 border border-gray-100 shadow-sm hover:shadow-md transition-all duration-300 cursor-grab active:cursor-grabbing mb-1"
      >
        <div className="flex justify-between items-start mb-3">
          <div className="flex flex-col gap-1">
            <div className="flex items-center gap-2">
              <span className="text-[13px] font-bold text-primary bg-primary/5 px-2 py-0.5 rounded-md">
                # {card.proforma_No}
              </span>
              {card.is_Urgent && (
                <span className="flex items-center gap-1 bg-red-50 text-red-600 text-[10px] px-2 py-0.5 rounded-full font-bold uppercase tracking-tight animate-pulse border border-red-100">
                  <span className="w-1 h-1 bg-red-600 rounded-full"></span>
                  Urgent
                </span>
              )}
            </div>
          </div>
          <button
            onClick={(e) => {
              e.stopPropagation();
              toggleMenu(card.proforma_No);
            }}
            className="p-1.5 rounded-lg text-gray-400 hover:text-primary hover:bg-gray-50 transition-colors"
          >
            <HiOutlineDotsVertical className="w-4 h-4" />
          </button>
        </div>

        <div onClick={() => handleEdit(card.proforma_No)} className="cursor-pointer">
          <h4 className="text-[15px] font-bold text-gray-800 line-clamp-1 mb-1 group-hover:text-primary transition-colors">
            {isCustomer[card.customer_Id] || "Customer Name Not Found"}
          </h4>

          <div className="flex flex-col gap-1.5 mb-2">
            <div className="flex items-center justify-between">
              <span className="text-[14px] font-bold text-gray-900">
                ₹{Number(card.net_Amount || 0).toLocaleString('en-IN')}
              </span>
              <span className="text-[12px] text-gray-500 font-medium">
                {salePersonName}
              </span>
            </div>
          </div>

          <div className="flex items-center justify-between pt-1 border-t border-gray-50">
            <div className="flex items-center gap-1.5 text-gray-500">
              <IoCalendarClearOutline className="w-3.5 h-3.5" />
              <span className="text-[12px] font-medium">
                {formatDateIndian(card.proforma_Date)}
              </span>
            </div>
            <div className="relative group/avatar">
              <div className="w-7 h-7 bg-primary rounded-full flex items-center justify-center text-[10px] font-bold text-white shadow-sm ring-2 ring-white">
                {initials}
              </div>
              <div className="absolute bottom-full right-0 mb-2 px-2 py-1 bg-gray-800 text-white text-[10px] rounded opacity-0 group-hover/avatar:opacity-100 transition-opacity whitespace-nowrap z-10 pointer-events-none">
                {salePersonName}
              </div>
            </div>
          </div>
        </div>

        {card.stage_Id === 7 && (
          <div className="mt-4 pt-3 border-t border-gray-50 flex items-center gap-2">
            <label className="relative flex items-center gap-2 cursor-pointer group/check">
              <input
                type="checkbox"
                className="peer hidden"
                checked={Boolean(card.invoice_Creation)}
                onChange={(e) => {
                  if (e.target.checked) {
                    setSelectedProformaForInvoice(card.proforma_No);
                    setIsInvoiceModalOpen(true);
                  }
                }}
              />
              <div className="w-4 h-4 border-2 border-gray-300 rounded peer-checked:bg-primary peer-checked:border-primary transition-all flex items-center justify-center">
                {Boolean(card.invoice_Creation) && (
                  <svg className="w-2.5 h-2.5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={4} d="M5 13l4 4L19 7" />
                  </svg>
                )}
              </div>
              <span className="text-[12px] font-semibold text-gray-600 group-hover/check:text-primary transition-colors">
                Invoice Done
              </span>
            </label>
          </div>
        )}

        {openMenuCard === card.proforma_No && (
          <div className="absolute right-4 top-12 w-48 bg-white border border-gray-100 shadow-xl rounded-xl z-[9999] overflow-hidden py-1 animate-in fade-in slide-in-from-top-2 duration-200">
            {permission.isUpdate && (
              <button
                onClick={() => handleEdit(card.proforma_No)}
                className="w-full flex items-center gap-3 px-4 py-2.5 text-[13px] font-medium text-gray-700 hover:bg-gray-50 hover:text-primary transition-colors"
              >
                <BiSolidEditAlt className="w-4 h-4" /> Edit Details
              </button>
            )}

            <button
              onClick={() => handlePrint(card.proforma_No)}
              className="w-full flex items-center gap-3 px-4 py-2.5 text-[13px] font-medium text-gray-700 hover:bg-gray-50 hover:text-primary transition-colors"
            >
              <IoPrintSharp className="w-4 h-4" /> Print PDF
            </button>

            {permission.isDelete && (
              <button
                onClick={() => handleDelete(card.proforma_No)}
                className="w-full flex items-center gap-3 px-4 py-2.5 text-[13px] font-medium text-red-600 hover:bg-red-50 transition-colors"
              >
                <MdDeleteForever className="w-4 h-4" /> Delete PI
              </button>
            )}

            {card.stage_Id === 7 && card.invoice_Pdf && (
              <button
                onClick={() => window.open(card.invoice_Pdf, "_blank")}
                className="w-full flex items-center gap-3 px-4 py-2.5 text-[13px] font-medium text-primary hover:bg-primary/5 transition-colors"
              >
                <BsFileEarmarkPdfFill className="w-4 h-4" /> View Invoice
              </button>
            )}

            {stageOptions[card.stage_Id]?.length > 0 && (
              <>
                <div className="h-px bg-gray-100 my-1" />
                <div className="px-4 py-1.5 text-[10px] font-bold text-gray-400 uppercase tracking-widest">Move To</div>
                {stageOptions[card.stage_Id].map((option) => (
                  <button
                    key={option}
                    onClick={() => handleCardMove(card.proforma_No, option, card.stage_Id)}
                    className="w-full flex items-center gap-3 px-4 py-2.5 text-[13px] font-medium text-gray-600 hover:bg-gray-50 hover:text-primary transition-colors"
                  >
                    <div className="w-1.5 h-1.5 rounded-full bg-gray-300" />
                    {option}
                  </button>
                ))}
              </>
            )}
          </div>
        )}
      </div>
    );
  };

  const handleInvoiceUpload = async () => {
    if (!invoiceFile) {
      notify("Please select a PDF file");
      return;
    }

    const formData = new FormData();
    formData.append("Proforma_No", selectedProformaForInvoice);
    formData.append("Invoice_Pdf", invoiceFile);

    try {
      const response = await axiosInstance.post(
        "FinsMaterialQuotations/SaveInvoicePdf",
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      const uploadedUrl = response?.data?.invoice_Pdf;

      setIsMaterialQuotationData((prev) =>
        prev.map((item) =>
          item.proforma_No === selectedProformaForInvoice
            ? {
              ...item,
              invoice_Creation: true,
              invoice_Pdf: uploadedUrl,
            }
            : item
        )
      );

      notify("Invoice uploaded successfully", "success");

      setIsInvoiceModalOpen(false);
      setInvoiceFile(null);
      fetchData();
    } catch (err) {
      console.error(err);
      notify("Error uploading invoice PDF");
    }
  };

  return (
    <>
      <Toast />
      <div >
        <div className="rounded-3xl bg-transparent px-2 pt-2 pb-6">
          {loading && (
            <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-75 z-9999">
              <Loader />
            </div>
          )}
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-8">
            <div>
              <h2 className="text-2xl font-bold text-gray-800">Fins Quotation Pipeline</h2>
              <p className="text-sm text-gray-500 font-medium">Manage and track your material quotations across different stages</p>
            </div>

            <div className="flex items-center gap-3 w-full md:w-auto">
              {permission.isInsert && (
                <button
                  className="flex-1 md:flex-none flex items-center justify-center gap-2 bg-primary hover:bg-primary/95 text-white px-6 py-2.5 rounded-xl font-bold shadow-lg shadow-primary/20 transition-all active:scale-95"
                  onClick={() => navigate("/quotes/fins-quotation/fins-Details")}
                >
                  <span>+</span> Add New PI
                </button>
              )}
              <button
                ref={filterBtnRef}
                className="flex items-center justify-center gap-2 bg-white hover:bg-gray-50 text-gray-700 px-5 py-2.5 rounded-xl font-bold shadow-sm border border-gray-100 transition-all active:scale-95"
                onClick={() => setIsFilterOpen((prev) => !prev)}
              >
                <RiFilter2Fill className="text-lg text-primary" />
                <span>Filters</span>
              </button>
            </div>
          </div>

          <Filter
            isOpen={isFilterOpen}
            onClose={() => setIsFilterOpen(false)}
            filterFields={filterFields}
            filters={filters}
            setFilters={setFilters}
            applyFilters={applyFilters}
            clearFilters={clearFilters}
          />

          <div className="h-full">
            <KanbanBoard
              columns={columns}
              cards={isMaterialQuotationData}
              onCardMove={handleCardMove}
              renderCard={renderCard}
            />
            <CloseLostModal
              isOpen={isCloseLostModalOpen}
              onClose={() => setIsCloseLostModalOpen(false)}
              onSave={handleCloseLostSave}
            />
          </div>
        </div>
        <Model
          isOpen={isDeleteModalOpen}
          onClose={() => setIsDeleteModalOpen(false)}
        >
          <div className="p-4 text-center">
            <p className="text-lg font-semibold mb-4">
              Are you sure you want to delete this site?
            </p>
            <div className="flex justify-center gap-4">
              <button
                className="bg-gray-5 px-4 py-2 rounded-md"
                onClick={() => setIsDeleteModalOpen(false)}
              >
                Cancel
              </button>
              <button
                className="bg-danger text-white px-4 py-2 rounded-md"
                onClick={handleConfirmDelete}
              >
                Delete
              </button>
            </div>
          </div>
        </Model>
        <Model
          isOpen={isInvoiceModalOpen}
          onClose={() => setIsInvoiceModalOpen(false)}
          name=" Upload Invoice PDF"
        >
          <div className="p-4">
            <input
              type="file"
              accept="application/pdf"
              onChange={(e) => setInvoiceFile(e.target.files[0])}
              className="mb-4 block w-full text-sm border border-gray-300 rounded-md p-2"
            />

            <div className="flex justify-end gap-3 mt-6">
              <button
                className="px-4 py-2 bg-gray-300 text-gray-800 rounded-md"
                onClick={() => {
                  setIsInvoiceModalOpen(false);
                  setInvoiceFile(null);
                }}
              >
                Cancel
              </button>
              <button
                className="px-4 py-2 bg-primary text-white rounded-md"
                onClick={handleInvoiceUpload}
              >
                Upload
              </button>
            </div>
          </div>
        </Model>
        <Model
          isOpen={isPdfModalOpen}
          onClose={() => {
            setPdfModalUrl(null);
            setIsPdfModalOpen(false);
          }}
          name="View Invoice PDF"
        >
          <div className="w-full h-[80vh]">
            {pdfModalUrl ? (
              <iframe
                src={pdfModalUrl}
                className="w-full h-full border-none"
                title="Invoice PDF"
              />
            ) : (
              <p>No PDF available.</p>
            )}
          </div>
        </Model>
      </div>
    </>
  );
};

export default FinsMaterialQuotation;
